import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomePage.vue";
import Layout from "@/views/layout/Layout.vue";
import AuthorityRouter from "./modules/AuthorityRouter";
import IndustrySolution from "./modules/industrySolution"
import Technology from "./modules/technology"
import BasicDataManagment from "./modules/BasicDataManagment";
import SGM from "./modules/SGM";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "home",
    children: [
      {
        path: "home",
        component: () => import("@/views/HomePage.vue"),
        name: "Home",
        meta: {
          title: "首页",
          noCache: true, // 不需要被缓存，缓存导致全屏 tags切换图表宽度不对
        },
      },
    ],
  },
  
];

const router = new VueRouter({
  routes: [...routes,
    ...AuthorityRouter,
    ...BasicDataManagment,
    ...IndustrySolution,
    ...Technology,
    ...SGM
  ]
});

export default router;
